import { Pipe, PipeTransform } from '@angular/core';
import { AlarmStatusCategory } from '../components/monitored-train-alarms/monitored-train-alarms.component';
import { MonitoringAlarm } from '../models/monitoring-alarm';

@Pipe({
  name: 'calculateAlarmStats'
})
export class CalculateAlarmStatsPipe implements PipeTransform {

  transform(alarmStatusCategories: AlarmStatusCategory[], allAlarms: MonitoringAlarm[], tableFilters: any, filteredAlarms: MonitoringAlarm[]): unknown {
    if (Object.keys(tableFilters).length > 0) {
      return this._calculateStats(alarmStatusCategories, filteredAlarms);
    } else {
      return this._calculateStats(alarmStatusCategories, allAlarms);
    }
  }

  _calculateStats = (alarmStatusCategories: AlarmStatusCategory[], alarms: MonitoringAlarm[]) => {
    return alarmStatusCategories.map(cat => {
      return {
        ...cat,
        total: cat.severity ? this._calculateCategoryStat(alarms, cat.acknowledged, cat.severity) : this._calculateCategoryStat(alarms, cat.acknowledged)
      };
    })
  }

  _calculateCategoryStat = (alarms: MonitoringAlarm[], acknowledged: boolean, severity?: number) : number => {
    if (alarms) {
      if (severity === undefined) {
        return alarms.reduce(function (total, issue) {
          total = total + (issue.acknowledged ===  acknowledged? 1 : 0);
          return total;
        }, 0);
      } else {
        return alarms.reduce(function (count, issue) {
            count += (!issue.acknowledged && issue.severity && issue.severity === severity) ? 1 : 0;
            return count;
        }, 0);
      }
    }
    return 0;
  }
}
